export const Vendors = () => {
  return <div>Coming Soon!</div>;
};
